import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reload",
  "use": "reload-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"reload\"><path d=\"M1.611 12c.759 0 1.375.57 1.485 1.32.641 4.339 4.389 7.68 8.903 7.68 5.476 0 9.827-4.917 8.867-10.569a8.95 8.95 0 0 0-4.523-6.313c-3.506-1.903-7.48-1.253-10.18 1.045l1.13 1.13c.63.63.184 1.707-.707 1.707H2a1 1 0 0 1-1-1V2.414c0-.891 1.077-1.337 1.707-.707l1.332 1.332C7.6-.115 12.921-1.068 17.637 1.408c3.32 1.743 5.664 5.027 6.223 8.735C24.982 17.58 19.227 24 12 24 5.979 24 .979 19.543.128 13.754-.007 12.834.681 12 1.611 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/reload.svg
// module id = lJZ5
// module chunks = 1